import { useEffect, useState } from "react";
import swal from "sweetalert";
import dayjs from "dayjs";

import { Button } from "../../elements/Button";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import commoncss from "../../css/common.module.css";
import { ReactComponent as CalendarIcon } from "../../assets/icons/Calendar.svg";
import { getAllConsolAutoAdjustmentsApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";

const AdjAutoPopulatedEntries = ({ history, consolID }) => {
  const [autoAdjustments, setAutoAdjustments] = useState([]);

  useEffect(() => {
    getAutoAdjustments();
  }, []);

  const getAutoAdjustments = (cat) => {
    const getParams = {
      category: cat,
      consolID: consolID,
    };
    getAllConsolAutoAdjustmentsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const autoAdjData = response?.data;
          setAutoAdjustments(autoAdjData?.autoAdjustments ?? []);
        } else {
          setAutoAdjustments([]);
          swal(
            "Error",
            response?.data?.error || "Unable to get auto adjustments",
            "error"
          );
        }
      })
      .catch((error) => {
        setAutoAdjustments([]);
        swal(
          "Error",
          error?.response?.data?.error || "Unable to populate auto adjustments",
          "error"
        );
      });
  };

  return (
    <>
      <div className={icrCss.header} style={{ justifyContent: "end" }}>
        <Button
          btnColor={buttoncss.primary}
          label="Populate FS"
          onClick={() => {
            history.push(`/myfinV2/console-populatefs/${consolID}`);
          }}
        />
      </div>
      <div className={icrCss.entrytableCtn} style={{paddingTop: "10px"}}>
        {autoAdjustments && autoAdjustments.length > 0 && 
          autoAdjustments.map((item, index) => (
            <div>
              <table className={`${icrCss.entrytable} mt-1 mb-3`}>
                <thead>
                  <th style={{ textAlign: "left", paddingLeft: "20px" }}>Particulars</th>
                  <th className="text-right" style={{ width: "200px" }}>
                    Current year
                  </th>
                  <th className="text-right" style={{ width: "200px", paddingRight: "30px" , whiteSpace: "noWrap"}}>
                    Previous year
                  </th>
                </thead>
                <tbody>
                  {item?.adjustments.map}
                  {item?.adjustments &&
                    item?.adjustments.map((adj, adj_index) => (
                      <tr key={index}>
                        <td style={{ textAlign: "left",  paddingLeft: "20px" }}>{adj.levelThree}</td>
                        <td className="text-right">
                          {adj.currentYear !== null && adj.currentYear !== undefined
                            ? (Number(adj.currentYear) < 0
                                ? `(${Math.abs(Number(adj.currentYear)).toLocaleString("en-IN")})`
                                : Number(adj.currentYear).toLocaleString("en-IN"))
                            : ""}
                        </td>

                        <td className="text-right" style={{ paddingRight: "30px" }}>
                          {adj.previousYear !== null && adj.previousYear !== undefined
                            ? (Number(adj.previousYear) < 0
                                ? `(${Math.abs(Number(adj.previousYear)).toLocaleString("en-IN")})`
                                : Number(adj.previousYear).toLocaleString("en-IN"))
                            : ""}
                        </td>
                         </tr>
                    ))}
                  <tr>
                    <td
                      colSpan={2}
                      className="text-left"
                      style={{
                        borderTop: "1px solid #EAEEED",
                        padding: "15px 20px",
                        paddingRight: "0px",
                      }}
                    >
                      {item.remarks && (
                        <div className={commoncss.headingColor}>
                          <strong >Remarks <span style={{ marginRight: "4px" }}></span></strong> {item.remarks}
                        </div>
                      )}
                    </td>
                    <td
                      style={{
                        "border-top": "1px solid #EAEEED",
                        "padding": "10px 0 10px 30px",
                      }}
                    >
                      {item.adjustmentDate && (
                        <span className={commoncss.tag3}>
                          {dayjs(item.adjustmentDate).format("DD-MMM-YYYY")}{" "}
                          <CalendarIcon
                            height={17}
                            style={{ marginLeft: "3px", verticalAlign: "sub" }}
                          />
                        </span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))}
        {autoAdjustments.length === 0 && (
          <table className={icrCss.entrytable}>
            <thead>
              <tr>
                <th className="text-left">Particulars</th>
                <th className="text-right">Current year</th>
                <th className="text-right">Previous year</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td colSpan={3}>No Adjustment Data</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default AdjAutoPopulatedEntries;
